export default function getStateFromPincode(pincode) {
  if (!pincode) return null;

  // Ensure it's a string and take first 3 digits
  const prefix = parseInt(String(pincode).substring(0, 3), 10);

  const ranges = [
    { state: "JAMMU AND KASHMIR", ranges: [[180, 194]] },
    { state: "HIMACHAL PRADESH", ranges: [[171, 177]] },
    { state: "PUNJAB", ranges: [[140, 160]] },
    { state: "CHANDIGARH", ranges: [[160, 160]] },
    { state: "UTTARAKHAND", ranges: [[244, 263]] },
    { state: "HARYANA", ranges: [[121, 136]] },
    { state: "DELHI", ranges: [[110, 110]] },
    { state: "RAJASTHAN", ranges: [[301, 345]] },
    { state: "UTTAR PRADESH", ranges: [[201, 285]] },
    { state: "BIHAR", ranges: [[800, 855]] },
    { state: "SIKKIM", ranges: [[737, 737]] },
    { state: "ARUNACHAL PRADESH", ranges: [[790, 792]] },
    { state: "NAGALAND", ranges: [[797, 798]] },
    { state: "MANIPUR", ranges: [[795, 795]] },
    { state: "MIZORAM", ranges: [[796, 796]] },
    { state: "TRIPURA", ranges: [[799, 799]] },
    { state: "MEGHALAYA", ranges: [[793, 794]] },
    { state: "ASSAM", ranges: [[781, 788]] },
    { state: "WEST BENGAL", ranges: [[700, 743]] },
    { state: "JHARKHAND", ranges: [[813, 835]] },
    { state: "ODISHA", ranges: [[751, 770]] },
    { state: "CHHATTISGARH", ranges: [[490, 497]] },
    { state: "MADHYA PRADESH", ranges: [[450, 488]] },
    { state: "GUJARAT", ranges: [[360, 396]] },
    { state: "DAMAN AND DIU", ranges: [[362, 362], [396, 396]] },
    { state: "DADRA AND NAGAR HAVELI", ranges: [[396, 396]] },
    { state: "MAHARASHTRA", ranges: [[400, 445]] },
    { state: "KARNATAKA", ranges: [[560, 591]] },
    { state: "GOA", ranges: [[403, 403]] },
    { state: "LAKSHADWEEP", ranges: [[682, 682]] },
    { state: "KERALA", ranges: [[670, 695]] },
    { state: "TAMIL NADU", ranges: [[600, 643]] },
    { state: "PUDUCHERRY", ranges: [[533, 533], [605, 605], [607, 607], [609, 609]] },
    { state: "ANDAMAN AND NICOBAR", ranges: [[744, 744]] },
    { state: "TELANGANA", ranges: [[500, 509]] },
    { state: "ANDHRA PRADESH", ranges: [[500, 535]] },
  ];

  for (let entry of ranges) {
    for (let [start, end] of entry.ranges) {
      if (prefix >= start && prefix <= end) {
        return entry.state;
      }
    }
  }

  return "Unknown State";
}